import React from 'react'
import Nav from './components/Navbar/Nav'

const App = () => {
  return (
    <div>
   <Nav/>
    </div>
  )
}

export default App
